<template>
  <transition name="fade" appear>
    <div class="Topbar">
      <div class="Topbar__head">
        <Choose3 accesskey="a"
            class="Topbar__adver" placeholder="Select Advertiser"
            :opts="Advers.list" filterable
            txtKey="name" valKey="id" :value="$root.adverId"
            @select="onSelectAdver"
        >
<!--           <template #opt-txt="{ opt }">
            {{ opt.name }}
          </template> -->
        </Choose3>

<!--         <AppItem v-else-if="$root.appId"
          class="Topbar__app" :item="Apps.byId[appId]" /> -->

        <template v-if="hasSelected">
          <!-- <Choose v-if="$root.app"
                  :value="appId" :opts="Apps.list" filterable :disabled="Apps.isEmpty"
                  textKey="name" valueKey="id" placeholder="Select application"
                  searchInPopup fullwidth accesskey="a" @input="onSelectApp">
            <template #trigger-text="{opt, value, placeholder}">
              <template v-if="opt">
                <Icon :name="opt.type" />
                <span>{{ opt.name }}</span>
              </template>
              <template v-else>{{ placeholder }}</template>
            </template>
            <template #opt="{opt}">
              <button type="button">
                <Icon :name="opt.type" />
                <span>{{ opt.name }}</span>
              </button>
            </template>
          </Choose> -->

          <!-- <h2 v-if="$root.adver">{{ $root.adver.name }}</h2> -->
<!--           <transition name="app-event" appear>
            <div v-if="mainEvent" class="Topbar__head-event">
              <Icon name="conversions" />
              <b>Main conversion:</b>
              <router-link class="u-ellipsis"
                  :to="{ name: ROUTES.CONVERSION, params: { id: mainEvent.id } }">
                {{ mainEvent.id }}. {{ mainEvent.name }}
              </router-link>
            </div>
          </transition> -->
        </template>
      </div>
      <div class="Topbar__identity" tabindex="-1" accesskey="p">
        <div>
          <header>{{ me.name }}</header>
          <span>{{ me.email }}</span><br>
          <span v-if="PERMS.BILLING.VIEW">{{ flt.number(me.account.balance) }} {{ currency }}</span>
        </div>
        <!-- <img :src="`https://avatars.dicebear.com/v2/identicon/${me.email}.svg`" /> -->
        <img :src="`https://secure.gravatar.com/avatar/${ gravaHash }?s=88&d=identicon`"
             alt="Your avatar">
        <div class="dropdown">
          <ul>
            <!-- <li><router-link :to="ROUTES.IDENTITY_PROFILE">
              <Icon name="profile" />
              Profile
            </router-link></li>
            <li v-if="PERMS.BILLING.VIEW"><router-link :to="{ name: ROUTES.BILLING }">
              <Icon name="billing" />
              Billing
            </router-link></li> -->

            <!-- <template v-if="PERMS.MANAGE.VIEW">
              <hr>
              <li>
                <router-link :to="ROUTES.MANAGE">
                  <Icon name="user-edit" />
                  Manage Account
                </router-link>
              </li>
              <li v-if="PERMS.ADMIN.VIEW">
                <router-link :to="ROUTES.ADMIN">
                  <Icon name="admin" />
                  Admin Panel
                </router-link>
              </li>
            </template> -->

            <!-- <hr> -->
            <li><button class="btn btn--clear" name="logout" type="button"
                @click="logout()">
              <Icon name="sign-out" />
              Logout
            </button></li>
          </ul>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import {
  Format,
  // upon,
  convolve,
} from 'utils';
import ROUTES from 'routes';
import Identity, { permsMixin } from 'store/identity.entity';
import Apps from 'store/apps.resource';
import Advers from 'store/advertisers.resource';
// import AppItem from 'pages/Apps/AppItem.vue';

export default {
  name: 'Topbar',
  mixins: [permsMixin],

  data: () => ({ Apps, Advers }),

  methods: {
    logout () { Identity.logout() },

    onSelectAdver (adver) {
      let { name } = this.$route;
      if (!name || !~name.indexOf(':appId'))
        name = ROUTES.ADVER.ROOT;

      this.$router.push({
        name,
        params: {
          ...this.$route.params,
          adverId: adver.id,
        },
      });
    },

    onSelectApp (appId) {
      const { query, params } = this.$route;
      let { name } = this.$route;

      if (!name || !~name.indexOf(':appId'))
        name = ROUTES.APP;

      params.appId = appId;
      this.$router.push({ name, params, query })
        .catch(() => null);
    },
  },

  computed: {
    me () { return Identity.data },

    appId () { return +this.$route.params.appId },

    gravaHash () { return convolve(`${ this.me.id }${ this.me.email }`) },

    currency () { return Format.currency(this.me.account.currency) },

    mainEvent () { return Apps.byId[this.appId]?.conversionEvent },
  },

  props: { hasSelected: [Boolean, Object] },

  components: {
    // AppItem,
  },
};

</script>
<style>
.Topbar {
  position: fixed;
  top: 0;
  left: calc((100vw - var(--page-w))/2 + var(--side-w));

  display: grid;
  grid-template-columns: minmax(100px, 1fr) minmax(200px, max-content);
  width: calc(var(--page-w) - var(--side-w));
  height: var(--topb-h);

  background-color: var(--white);
  border-bottom: 1px solid var(--black-10);

  z-index: var(--zi-topb, 100);
  will-change: left;
  transition: all .2s;

  &--fixed {
    .Topbar {
      position: fixed;
    }

    .Table th {
      position: sticky;
      top: var(--topb-h);
    }
  }

  &.fade-enter-active {
    transition-delay: .3s;
  }

  > * {
    padding: 10px var(--main-pad);
    /*padding: var(--main-pad);*/
    display: flex;
    align-items: center;
  }

  &__app {
    margin-left: -8px;
  }

  &__adver {
    .Choose3__trigger {
      width: auto;
      margin-left: calc(-1 * var(--input-p));

      font-weight: 600;
      font-size: 18px;

      --border-c: transparent;
    }
  }

  &__head {
    width: 100%;
    max-width: 800px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding-left: var(--main-pad);

    .Choose__searchInPopup > .__el {
      height: 36px;

      .input__icon {
        top: 10px;
        right: 10px;
      }
    }

    > * {
      max-width: 100%;
    }

    &-event {
      display: flex;
      margin-left: 12px;
      margin-bottom: 8px;
      margin-top: -2px;
      transition: all .4s;
      font-size: 13px;
      transform: translateY(0);
      opacity: 1;
      position: relative;
      white-space: nowrap;

      > * {
        height: 16px;
      }

      b {
        font: 600 13px Montserrat;
        margin-right: 8px;
        margin-left: 28px;
        user-select: none;
      }

      i {
        width: 24px;
        margin-right: 6px;
        vertical-align: top;
        position: absolute;
        left: 0;

        svg {
          fill: var(--black);
        }
      }
    }

    .Choose__trigger {
      border: none;
      font: 600 18px Montserrat;
      height: auto;
      /*min-width: auto;*/
      color: var(--black);

      &:focus {
        /*border-color: none;*/
        box-shadow: 0 0 0 3px var(--black-10) inset;
      }

      span {
        padding-left: 28px;
      }

      i:not(:first-child) {
        width: 24px;
        height: 24px;
        margin-top: -2px;
        position: absolute;
      }
    }

    .Choose__icon {
      margin-top: 2px;
    }

    .Choose__opt {
      height: 38px;
    }

    .Choose__opt button {
      width: 100%;
      text-align: left;
      font: inherit;
      line-height: 24px;
      cursor: pointer;
      outline: none !important;
      /*height: inherit%;*/

      &:focus:not(:hover) {
        border-bottom: 1px dashed var(--black-50);
      }
    }

    .Choose__opt i {
      opacity: .7;
      margin-right: 8px;
    }
  }

  &__identity {
    /*border-left: 1px solid var(--black-10);*/
    position: relative;
    white-space: nowrap;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    text-align: right;
    transition: .2s all;

    outline: none;

    &:hover, &:focus {
      background-color: var(--black-10);

      img {
        box-shadow: 0 0 0 3px var(--black-10);
      }
    }

    header {
      font: 400 14px/18px Montserrat;
    }

    span {
      font: 400 10px/16px Montserrat;

      &:last-child { user-select: none }
    }

    img {
      width: 44px;
      height: 44px;
      border-radius: 100%;
      margin-left: var(--main-pad);
      transition: .2s all;
      box-shadow: 0 0 0 3px transparent;
    }

    .dropdown {
      right: 0;
      top: calc(100% - 3px);
      opacity: 0;
      transition: .2s all;
      pointer-events: none;

      hr {
        height: 1px;
        background-color: var(--black-10);
      }
    }

    &:hover, &:focus {
      .dropdown {
        opacity: 1;
        pointer-events: all;
        transition-delay: .2s;
      }
    }

    .dropdown li {
      cursor: pointer;
      text-align: left;
      font: var(--input-font);
      color: var(--black);
      width: auto;
      min-width: 200px;
      max-width: 100%;
      height: var(--input-h);
      padding: 0;
      height: 40px;
      /*padding: 0 var(--input-p);*/
      box-shadow: 0 0 0 0 transparent;
      background: white;

      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;

      > * {
        line-height: 40px;
        text-align: left;
        padding: 0 var(--input-p);
        display: inline-block;
        height: 100%;
        width: 100%;
        transition: .2s all;

        &, &:visited { color: var(--black) }

        i {
          margin-right: 8px !important;
          svg {
            fill: var(--black);
          }
        }

        &.router-link-exact-active {
          color: var(--black-50);
          pointer-events: none;
        }

        &:hover, &:focus, &:active, &:visited {
          background-color: var(--black-10);
        }
      }
    }
  }

  .Choose {
    &__search {
      i {
        top: 10px;
        right: initial;
        left: 11px;
      }

      input {
        border: 0;
        font: 400 18px / 18px Montserrat;
        padding: 7px 33px;
        height: auto;

        &::placeholder {
          opacity: .8;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }

    .ContextMenu {
      max-height: calc(100vh - 22px * 2);
      overflow-y: auto;
      padding-top: 36px;
      min-height: 36px;
    }

    .Popover__trigger {
      text-align: left;
      z-index: initial;
    }

    .Popover__content {
      position: absolute;
      top: -3px;
      left: -3px;
    }

    .Choose__trigger.__el { width: auto; }

    .__el:disabled {
      color: var(--black-50);
      background-color: transparent;
    }
  }
}

.app-event-enter-from, .app-event-leave-to {
  height: 0;
  margin-top: 0;
  margin-bottom: 0;
  opacity: 0;
  transform: translateY(10px);
}

.t-sidebar-mini .Topbar {
  width: calc(var(--page-w) - var(--side-mini-w));
  left: calc((100vw - var(--page-w))/2 + var(--side-mini-w));
}
</style>
